import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Badge,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import HostelPage from '../../views/HostelPage/';
import Pagination from "react-js-pagination";
import Loader from '../../Loader';

class HostelList extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			modal: false,
			modal1: false,
			hname : '',
			haddr : '',
			idd : '',
			loading: false,
			_message : '',
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			alertClass :'',
			posts: []
			
		}
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onupdateSubmit = this.onupdateSubmit.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}
	
	toggle(){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	toggle1(){
		this.setState({
		  modal1: !this.state.modal1
		});
	}
	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
			this.getdata();
	}
	
	addtoggle(e){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	addtoggle1(e){
		this.setState({
		  modal1: !this.state.modal1
		});
	}
	
   componentWillMount() {
		 
		this.getdata();
		
	}
	
	onChange(e){
		
		this.setState({[e.target.name] : e.target.value});
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.gethostdata();
		
	}
	
	gethostdata(){
		
		GetData('hostel/gethostelbyid/'+this.state.idd).then((result) => {
			let res = result;
			if(res){
				this.setState({
					hname : res[0]['name'],
					haddr : res[0]['address'],
					hphone : res[0]['phone'],
					hincharge : res[0]['inchargename'],
					hwarden : res[0]['wardenname'],
					hmfee : res[0]['messfee'],
					modal1: !this.state.modal1
				});
			}
		});
	}
	
	onSubmit(e){
		
		e.preventDefault();
		if(this.state!=''){
			
			PostData('hostel/addhostel',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Hostel Added Successfully!..',
						alertClass:'alert alert-success',
						modal: !this.state.modal
					});
					document.getElementById("cform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
					document.getElementById("cform").reset();
					this.getdata();
				}
			});
		
		}
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('hostel/deletehostel',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Hostel Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Hostel',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onupdateSubmit(e){
		e.preventDefault();
		console.log(this.state);
		if(this.state.idd){
			
			PostData('hostel/updatehostel',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Hostel Updated Successfully!..',
						alertClass:'alert alert-success',
						modal1: !this.state.modal1
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
					this.getdata();
				}
			});
		
		}
	
	}
	
	getdata(){
		this.setState({loading:true});
		GetData('hostel/gethostel').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					loading:false
				});
			}
		});
	}
	
  render() {
	  
	 
	  
	  /** set showcount select box **/
	this.shows = [
		{value : '10', name : '10'},
		{value : '20', name : '20'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.posts.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
	  return <tr key = {item}>
								<td width="20">{i+1}</td>
								<td width="100">{item.name}</td>
								<td width="100">{item.address}</td>
								<td width="100">{item.inchargename}</td>
								<td width="100">{item.wardenname}</td>
								<td width="30">
									<button name="edithw" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
									&nbsp;&nbsp;
									<button name="removeann" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>;
		
	});
	  
    return (
		<div>
		  <HostelPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			<Row>
			<Col md="12">
				<Card>
				  <CardHeader>
					<strong>Hostel List</strong>
					<Button className="btn-right" size="sm" color="primary" onClick={this.addtoggle.bind(this)}><i className="fa fa-plus"> Add</i></Button>
				  </CardHeader>
				  <CardBody>
					<Row>
					  <Col md="12">
					 
						<Table responsive>
						  <thead>
							<tr>
							  <th>S.No</th>
							  <th>Name</th>
							  <th>Address</th>
							  <th>Incharge</th>
							  <th>Warden</th>
							  <th>Manage</th>
							</tr>
						  </thead>
						  <tbody>
							{this.state.loading ?  <tr><td colSpan="6"><center><Loader /></center></td></tr> : renderTodos}
						</tbody>
						</Table>
					  </Col>
					  <Col md="4">
					  <Pagination
								 activePage={this.state.activePage}
								 itemsCountPerPage={this.state.todosPerPage}
								 pageRangeDisplayed={3}
								 totalItemsCount={this.state.posts.length}
								 onChange={this.handlePageChange}
								/>
					  </Col>
					  <Col md="2">
					   <select name="show" onChange={this.onShowChange} id="show" >
									{this.shows.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>&nbsp;
							entries
					  </Col>
					  <Modal isOpen={this.state.modal} toggle={this.addtoggle} className={this.props.className}>
						<form action="" method="post" role="form" id="cform" encType="multipart/form-data" onSubmit={this.onSubmit}>
						  <ModalHeader toggle={this.toggle}>Add Hostel</ModalHeader>
						  <ModalBody>
							<Row>
							  <Col md="3">
								<FormGroup>
									<Label>Name</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="text" name="hname" onChange={this.onChange} required />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Address</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="textarea" name="haddr" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Phone</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="text" name="hphone" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Incharge</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="text" name="hincharge" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Warden</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="text" name="hwarden" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Mess Fee</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="number" name="hmfee" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						  </ModalBody>
						  <ModalFooter>
							<Button type="submit" color="primary" >Save</Button>{' '}
							<Button color="secondary" onClick={this.toggle}>Cancel</Button>
						  </ModalFooter>
						</form>
					  </Modal>
					  
					  <Modal isOpen={this.state.modal1} toggle={this.addtoggle1} className={this.props.className}>
						<form action="" method="post" role="form" id="chform" encType="multipart/form-data" onSubmit={this.onupdateSubmit}>
						  <ModalHeader toggle={this.toggle1}>Update Hostel</ModalHeader>
						  <ModalBody>
							<Row>
							  <Col md="3">
								<FormGroup>
									<Label>Name</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="text" name="hname" onChange={this.onChange} value={this.state.hname} required />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Address</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="textarea" name="haddr" onChange={this.onChange} value={this.state.haddr} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Phone</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="text" name="hphone" onChange={this.onChange} value={this.state.hphone} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Incharge</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="text" name="hincharge" onChange={this.onChange} value={this.state.hincharge} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Warden</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="text" name="hwarden" onChange={this.onChange} value={this.state.hwarden} />
								</FormGroup>
							  </Col>
							   <Col md="3">
								<FormGroup>
									<Label>Mess Fee</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<Input type="number" name="hmfee" onChange={this.onChange} value={this.state.hmfee} />
								</FormGroup>
							  </Col>
							</Row>
						  </ModalBody>
						  <ModalFooter>
							<Button type="submit" color="primary" >Update</Button>{' '}
							<Button color="secondary" onClick={this.toggle1}>Cancel</Button>
						  </ModalFooter>
						</form>
					  </Modal>
					</Row>
				  </CardBody>
				</Card>
			</Col>
			</Row>
			</div>
		</div>
    );
  }
}

export default HostelList;



// WEBPACK FOOTER //
// ./src/hostel/HostelList/HostelList.js